<template>
  <ag-card-container
    :search.sync="search"
    :title="$t('trainingsession.title.main')"
    fluid
  >
    <session-list
      :value="sessionList"
      :selected.sync="selectedSessionList"
      :loading="loadingData"
      :search="search"
    />
    <ag-float-button-container>
      <ag-confirm-dialog
        v-if="selectedSessionList.length"
        :title="$t('general.confirmation')"
        :message="removeMessage"
        :cancel-label="$t('general.cancel')"
        :confirm-label="$t('general.remove')"
        validation-btn-color="error"
        @confirm="removeSelected"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            :loading="loadingRemove"
            color="error"
            fab
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-delete</v-icon>
            <v-chip
              x-small
              class="px-1 float-chip font-weight-black"
              color="white"
              text-color="error"
              v-text="selectedSessionList.length"
            />
          </v-btn>
        </template>
      </ag-confirm-dialog>
      <v-btn
        to="/trainingsession/create"
        color="accent"
        fab
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </ag-float-button-container>

    <!-- RouterView for modals -->
    <router-view />
  </ag-card-container>
</template>

<script>
import AgCardContainer from 'src/components/common/AgCardContainer'
import AgFloatButtonContainer from 'src/components/common/AgFloatButtonContainer'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'
import SessionList from '../components/SessionList'

export default {
  name: 'SessionListContainer',
  components: {
    AgCardContainer,
    AgFloatButtonContainer,
    AgConfirmDialog,
    SessionList,
  },
  data: () => ({
    sessionList: [],
    selectedSessionList: [],
    search: '',
    loadingData: false,
    loadingRemove: false,
  }),
  computed: {
    tokenToRefunds () {
      return this.selectedSessionList
        .reduce((sum, session) => sum + (session.status === 'created' ? session.nbPlayer : 0), 0)
    },
    removeMessage () {
      const count = this.selectedSessionList.length
      const message = this.$tc('trainingsession.remove.confirm', count, { count })

      if (this.tokenToRefunds) {
        const refundMessage = this.$tc('trainingsession.remove.refundToken', this.tokenToRefunds, {
          tokenToRefunds: this.tokenToRefunds,
        })
        return `${message}\n\n${refundMessage}`
      }

      return message
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'TrainingsessionSessionList') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    async fetchData () {
      this.loadingData = true
      this.sessionList = await Repositories.trainingSession.session.getList()
      this.loadingData = false
    },
    async removeSelected () {
      try {
        this.loadingRemove = true
        const count = this.selectedSessionList.length
        const idList = this.selectedSessionList.map(session => session.id)
        await Repositories.trainingSession.session.delete(idList)
        const notification = this.$tc('trainingsession.remove.success', count, { count })
        this.showSuccessNotification(notification)
      }
      catch (error) {
        const notification = Repositories.parseErrorMessage(error)
        this.showErrorNotification(notification)
      }
      finally {
        this.loadingRemove = false
        this.selectedSessionList = []
        this.fetchData()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.float-chip {
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 12px;
}
</style>
